"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeartOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.296 1.978A4.854 4.854 0 004.4 1C1.932 1 0 2.889 0 5.302c0 2.952 2.718 5.364 6.835 9.018l.465.413a1.05 1.05 0 001.4 0l.465-.413C13.282 10.666 16 8.254 16 5.302 16 2.889 14.068 1 11.6 1A4.854 4.854 0 008 2.63a4.65 4.65 0 00-.704-.652zm.815 11.091c2.093-1.857 3.696-3.285 4.795-4.6 1.084-1.297 1.486-2.264 1.486-3.167 0-1.419-1.133-2.646-2.792-2.646A3.26 3.26 0 009.195 3.74L8 5.106 6.805 3.739A3.26 3.26 0 004.4 2.656c-1.66 0-2.792 1.227-2.792 2.646 0 .903.402 1.87 1.486 3.167 1.1 1.315 2.703 2.743 4.796 4.6l.11.098.11-.098z",
    clipRule: "evenodd"
  })))
});
HeartOutlineIcon.displayName = 'HeartOutlineIcon';
var _default = exports.default = HeartOutlineIcon;